// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import Bell from "@store/Library/Components/Toolkit/Icons/Bell/BellFill";
import Bookmark from "@store/Library/Components/Toolkit/Icons/Bookmark/BookmarkFill";
import Calendar from "@store/Library/Components/Toolkit/Icons/Calendar/CalendarFill";
import Car from "@store/Library/Components/Toolkit/Icons/Car/CarFill";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import Clock from "@store/Library/Components/Toolkit/Icons/Clock/ClockFill";
import Copy from "@store/Library/Components/Toolkit/Icons/Copy/CopyFill";
import Edit from "@store/Library/Components/Toolkit/Icons/Edit/EditFill";
import Email from "@store/Library/Components/Toolkit/Icons/Email/EmailFill";
// import Export from "@store/Library/Components/Toolkit/Icons/Export"; // Store Custom Code
// import ExternalLink from "@store/Library/Components/Toolkit/Icons/ExternalLink"; // Store Custom Code
import Eye from "@store/Library/Components/Toolkit/Icons/Eye/EyeFill";
import Globe from "@store/Library/Components/Toolkit/Icons/Globe/GlobeFill";
import Heart from "@store/Library/Components/Toolkit/Icons/Heart/HeartFill";
// import Import from "@store/Library/Components/Toolkit/Icons/Import"; // Store Custom Code
import Navigation2 from "@store/Library/Components/Toolkit/Icons/Navigation2/Navigation2Fill";
import Options2 from "@store/Library/Components/Toolkit/Icons/Options2/Options2Fill";
import PersonAdd from "@store/Library/Components/Toolkit/Icons/PersonAdd/PersonAddFill";
import Pin from "@store/Library/Components/Toolkit/Icons/Pin/PinFill";
import PlusCircle from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import Save from "@store/Library/Components/Toolkit/Icons/Save/SaveFill";
// import Search from "@store/Library/Components/Toolkit/Icons/Search"; // Store Custom Code
import Settings from "@store/Library/Components/Toolkit/Icons/Settings/SettingsFill";
import ShoppingCart from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";
import Tag from "@store/Library/Components/Toolkit/Icons/Tag/TagLine";
import Trash from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

/* Store Custom Code - Start */
import History from "@store/Library/Components/Icons/History";
import Receipt from "@store/Library/Components/Icons/Receipt";
import UserSettings from "@store/Library/Components/Icons/UserSettings";
import BellLine from "@store/Library/Components/Toolkit/Icons/Bell/BellLine";
import BookmarkLine from "@store/Library/Components/Toolkit/Icons/Bookmark/BookmarkLine";
import CalendarLine from "@store/Library/Components/Toolkit/Icons/Calendar/CalendarLine";
import CarLine from "@store/Library/Components/Toolkit/Icons/Car/CarLine";
import ClockLine from "@store/Library/Components/Toolkit/Icons/Clock/ClockLine";
import CopyLine from "@store/Library/Components/Toolkit/Icons/Copy/CopyLine";
import EditLine from "@store/Library/Components/Toolkit/Icons/Edit/EditLine";
import EmailLine from "@store/Library/Components/Toolkit/Icons/Email/EmailLine";
import Export from "@store/Library/Components/Toolkit/Icons/Export";
import ExternalLink from "@store/Library/Components/Toolkit/Icons/ExternalLink";
import EyeLine from "@store/Library/Components/Toolkit/Icons/Eye/EyeLine";
import GlobeLine from "@store/Library/Components/Toolkit/Icons/Globe/GlobeLine";
import HeartLine from "@store/Library/Components/Toolkit/Icons/Heart/HeartLine";
import Import from "@store/Library/Components/Toolkit/Icons/Import";
import Navigation2Line from "@store/Library/Components/Toolkit/Icons/Navigation2/Navigation2Line";
import Options2Line from "@store/Library/Components/Toolkit/Icons/Options2/Options2Line";
import PersonAddLine from "@store/Library/Components/Toolkit/Icons/PersonAdd/PersonAddLine";
import PinLine from "@store/Library/Components/Toolkit/Icons/Pin/PinLine";
import PlusCircleLine from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleLine";
import SaveLine from "@store/Library/Components/Toolkit/Icons/Save/SaveLine";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import SettingsLine from "@store/Library/Components/Toolkit/Icons/Settings/SettingsLine";
import ShoppingCartLine from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartLine";
import TagLine from "@store/Library/Components/Toolkit/Icons/Tag/TagLine";
import TrashLine from "@store/Library/Components/Toolkit/Icons/Trash/TrashLine";
/* Store Custom Code - End */

export type ButtonIconOption = DataOption<IconPresentationProps["src"]>;
export interface ButtonIconOptionMapper {
    none: ButtonIconOption;
    arrowForward: ButtonIconOption;
    arrowBackward: ButtonIconOption;
    chevronRight: ButtonIconOption;
    chevronLeft: ButtonIconOption;
}
export type ButtonIconOptions = DataOptions<ButtonIconOption> & ButtonIconOptionMapper;
export type ButtonIcon = LiteralUnion<keyof ButtonIconOptionMapper>;

export const buttonIconOptions: ButtonIconOptions = {
    none: { id: "none", displayName: "None", value: "", isDefault: true },
    arrowForward: { id: "arrowForward", displayName: "Arrow Forward", value: ArrowForward },
    arrowBackward: { id: "arrowBackward", displayName: "Arrow Backward", value: ArrowBackward },
    bell: { id: "bell", displayName: "Bell", value: BellLine }, // Store Custom Code
    bookmark: { id: "bookmark", displayName: "Bookmark", value: BookmarkLine }, // Store Custom Code
    calendar: { id: "calendar", displayName: "Calendar", value: CalendarLine }, // Store Custom Code
    cart: { id: "cart", displayName: "Cart", value: ShoppingCartLine }, // Store Custom Code
    chevronRight: { id: "chevronRight", displayName: "Chevron Right", value: ChevronRight },
    chevronLeft: { id: "chevronLeft", displayName: "Chevron Left", value: ChevronLeft },
    clock: { id: "clock", displayName: "Clock", value: ClockLine }, // Store Custom Code
    cog: { id: "cog", displayName: "Cog", value: SettingsLine }, // Store Custom Code
    copy: { id: "copy", displayName: "Copy", value: CopyLine }, // Store Custom Code
    email: { id: "email", displayName: "Email", value: EmailLine }, // Store Custom Code
    export: { id: "export", displayName: "Export", value: Export },
    external: { id: "external", displayName: "External", value: ExternalLink },
    eye: { id: "eye", displayName: "Eye", value: EyeLine }, // Store Custom Code
    globe: { id: "globe", displayName: "Globe", value: GlobeLine }, // Store Custom Code
    heart: { id: "heart", displayName: "Heart", value: HeartLine }, // Store Custom Code
    import: { id: "import", displayName: "Import", value: Import },
    navigation: { id: "navigation", displayName: "Navigation", value: Navigation2Line }, // Store Custom Code
    options: { id: "options", displayName: "Options", value: Options2Line }, // Store Custom Code
    pencil: { id: "pencil", displayName: "Pencil", value: EditLine }, // Store Custom Code
    pin: { id: "pin", displayName: "Pin", value: PinLine }, // Store Custom Code
    plusCircle: { id: "plusCircle", displayName: "Plus (Circled)", value: PlusCircleLine }, // Store Custom Code
    save: { id: "save", displayName: "Save", value: SaveLine }, // Store Custom Code
    search: { id: "search", displayName: "Search", value: Search },
    shipping: { id: "shipping", displayName: "Shipping", value: CarLine }, // Store Custom Code
    tag: { id: "tag", displayName: "Tag", value: TagLine }, // Store Custom Code
    trash: { id: "trash", displayName: "Trash Bin", value: TrashLine }, // Store Custom Code
    userPlus: { id: "userPlus", displayName: "User Plus", value: PersonAddLine }, // Store Custom Code
    // Store Custom Code
    history: { id: "history", displayName: "History", value: History },
    receipt: { id: "receipt", displayName: "Receipt", value: Receipt },
    userSettings: { id: "userSettings", displayName: "User Settings", value: UserSettings },
};

export type ButtonIconFieldValue = ButtonIcon | undefined;
export interface ButtonIconFieldOptions {
    isChildDefinition?: boolean;
}

export const getButtonIconFieldData = (value: ButtonIconFieldValue, options?: ButtonIconFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(buttonIconOptions, value);
};

export const getButtonIconFieldDefinition = (name: string, options?: ButtonIconFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(buttonIconOptions),
        name,
        displayName: "Button Icon",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getButtonIconField = (name: string, options?: ButtonIconFieldOptions) => {
    const parse = (value: ButtonIconFieldValue) => getButtonIconFieldData(value, options);

    return {
        definition: getButtonIconFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getButtonIconField;
